import React from "react";
import * as Redux from 'react-redux';

export class Loader extends React.Component {
	render() {
		var {loading} = this.props;
		
		if (loading && loading.length > 0) {
			var lastLoading = loading[loading.length-1];
			return <div className="ygl-loading"><i className="fa fa-spinner fa-spin"></i> {lastLoading}</div>;
		} else {
			return <div></div>;
		}
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(Loader);


// WEBPACK FOOTER //
// ./src/components/Loader.js